import { render, staticRenderFns } from "./RmpAccessDeniedError.vue?vue&type=template&id=782e6d39"
import script from "./RmpAccessDeniedError.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpAccessDeniedError.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports